import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

// RTK 2 types `action.payload` as `unknown` for rejected-with-value actions,
// since the payload shape is up to the caller. Narrow it before reading.
const extractErrorMessage = (payload: unknown): string => {
  if (
    typeof payload === 'object' &&
    payload !== null &&
    'data' in payload &&
    typeof (payload as { data?: unknown }).data === 'string'
  ) {
    return (payload as { data: string }).data;
  }
  return 'Something went wrong';
};

export const middlewareErrorToast: Middleware = () => (next) => (action) => {
  let errorMessage = '';

  if (isRejectedWithValue(action)) {
    errorMessage = extractErrorMessage(action.payload);
  }

  if (errorMessage) {
    toast.error(errorMessage);
  }

  return next(action);
};
